import React from "react";
import styled, { css } from "styled-components";
import moment from "moment";
import { capitalize, currentLanguage } from "helpers";

import GridElement from "partials/GridElement";
import SmartLink from "partials/SmartLink";
import Button from "partials/Button";
import FavoriteButton from "partials/FavoriteButton";

const MobileEventInfo = (props) => {
  const getDate = (date) => {
    return (
      capitalize(moment(date).format("dddd D.")) +
      " " +
      capitalize(moment(date).format("MMM YYYY"))
    );
  };
  const getTime = (date) => {
    return currentLanguage() === "no"
      ? ", kl. "
      : ", at " + moment(date).format("H:mm");
  };
  const getDateRange = (from, to) => {
    return (
      moment(from).format("D.") +
      " " +
      capitalize(moment(from).format("MMM")) +
      " - " +
      moment(to).format("D.") +
      " " +
      capitalize(moment(to).format("MMM YYYY"))
    );
  };
  const getTravelizeUrl = () => {
    return `https://svalbardadventures.travelize24.com/clientfiles/svalbardbooking.asp?WebSiteUser=ssWeb&productcode=${
      data.acf.travelize_id
    }&showpicture=no&showtext=no&lang=${
      currentLanguage() === "no" ? "NO" : "UK"
    }`;
  };

  const { data } = props;

  return (
    <StyledGridElement
      colStart={1}
      colEnd={8}
      flex={data.acf.web_page_url ? 1 : 0}
    >
      <FlexGroup
        hasButton={
          (data.acf.button_link || data.acf.travelize_id) &&
          (data.acf.e_billett_button_text || data.acf.travelize_button_text)
            ? 1
            : 0
        }
      >
        {data.acf.from_date && !data.acf.end_date && (
          <ContentWrapper>
            <div>
              <span>
                {getDate(data.acf.from_date).toUpperCase()}
                {data.acf.display_starting_time
                  ? getTime(data.acf.from_date).toUpperCase()
                  : null}
              </span>
              <span>•</span>
              <span>{"NOK " + data.acf.price}</span>
              <span>•</span>
            </div>
            {data.acf.web_page_url && (
              <div>
                <span>
                  <a href={"https://" + data.acf.web_page_url} target='_blank'>
                    {data.acf.web_page_url.title.toUpperCase()}
                  </a>
                </span>
              </div>
            )}
          </ContentWrapper>
        )}
        {data.acf.from_date && data.acf.end_date && (
          <ContentWrapper>
            <div>
              <span>
                {getDateRange(
                  data.acf.from_date,
                  data.acf.end_date
                ).toUpperCase()}
              </span>
              <span>•</span>
              <span>{"NOK " + data.acf.price}</span>
              <span>•</span>
            </div>
            {data.acf.web_page_url && (
              <div>
                <span>
                  <a href={data.acf.web_page_url.url} target='_blank'>
                    {data.acf.web_page_url.title.toUpperCase()}
                  </a>
                </span>
              </div>
            )}
          </ContentWrapper>
        )}
      </FlexGroup>
      <StyledFavoriteButton
        item={data}
        sort={data.type}
        absolute={
          (data.acf.e_billett_button_text && data.acf.button_link) ||
          (data.acf.travelize_button_text && data.acf.travelize_id)
            ? 1
            : 0
        }
      />
      {data.acf.e_billett_button_text && data.acf.button_link && (
        <StyledSmartLink to={data.acf.button_link} target='_blank'>
          <StyledButton>{data.acf.e_billett_button_text}</StyledButton>
        </StyledSmartLink>
      )}
      {data.acf.travelize_button_text && data.acf.travelize_id && (
        <StyledSmartLink to={getTravelizeUrl()} target='_blank'>
          <StyledButton>{data.acf.travelize_button_text}</StyledButton>
        </StyledSmartLink>
      )}
    </StyledGridElement>
  );
};

export default MobileEventInfo;

const StyledGridElement = styled(GridElement)`
  display: ${(props) => (props.flex ? "flex" : "block")};
  margin-bottom: ${(props) => props.theme.spacing.elementXS};
`;

const StyledSmartLink = styled(SmartLink)``;

const StyledButton = styled(Button)`
  width: 100%;
  padding: ${(props) => props.theme.spacing.contentS};
`;

const ContentWrapper = styled.div`
  align-items: center;
  margin-right: ${(props) => props.theme.spacing.elementXS};

  svg {
    margin-right: ${(props) => props.theme.spacing.contentM};
    fill: ${(props) => props.theme.colors.text};
  }

  span {
    display: inline;
    font-size: 11px;
    line-height: 21px;
    margin-right: 6px;
  }

  a {
    color: ${(props) => props.theme.colors.link};
    text-decoration: underline;
  }
`;

const FlexGroup = styled.div`
  display: flex;
  width: 100%;

  ${(props) =>
    props.hasButton &&
    css`
      margin-bottom: ${props.theme.spacing.contentM};
    `}
`;

const StyledFavoriteButton = styled(FavoriteButton)`
  margin: auto 0 auto auto;

  ${(props) =>
    props.absolute &&
    css`
      position: absolute;
      top: 0;
      right: 0;
    `};
`;
